import React from 'react';
import { SidebarItem, type SidebarItemProps } from './SidebarItem';

/**
 * SidebarSection Component - Molecular Level
 * 
 * Groups sidebar items under a section heading
 * 
 * Features:
 * - Section title
 * - Collapsible support
 * - Multiple navigation items
 */

export interface SidebarSectionProps {
  /** Section title */
  title?: string;
  /** Navigation items in this section */
  items: SidebarItemProps[];
  /** Whether sidebar is collapsed */
  isCollapsed?: boolean;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  items,
  isCollapsed = false,
}) => {
  return (
    <div className="py-2">
      {/* Section Title */}
      {title && !isCollapsed && (
        <div className="px-4 py-2">
          <h3 className="!text-xs !font-semibold !text-white !uppercase !tracking-wider !m-0 !text-left">
            {title}
          </h3>
        </div>
      )}

      {/* Section Items */}
      <nav className="space-y-1" role="navigation">
        {items.map((item, index) => (
          <SidebarItem
            key={item.path || item.label || index}
            {...item}
            isCollapsed={isCollapsed}
          />
        ))}
      </nav>
    </div>
  );
};

export default SidebarSection;

